//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockOutgoing', {
//        templateUrl: 'views/components/views/stockOutgoing/stockOutgoing.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stockOutgoingService', function ($stateParams, stockOutgoingService) {
//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;
            
//            vm.model = {
//                itemsListStockOutgoings: []
//            };

//            async function loadStockOutgoings() {
//                vm.model.itemsListStockOutgoings = await stockOutgoingService.listStockOutgoings({ stock_keyno: stockKeyno });
//            }

//            vm.$onInit = function () {
//                loadStockOutgoings();
//            };
//        }]
//    });
//})();
